import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Crosshairs } from './components/Crosshairs';
import { Seo } from './components/Seo';
import { Analytics } from './components/Analytics';
import { Index } from './pages/Index';
import { How } from './pages/How';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
import { Post } from './pages/Post';
import { OgCard } from './pages/OgCard';
import { FaviconCard } from './pages/FaviconCard';
function Shell() {
  const pageRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  useEffect(() => {
    // A hash means the link targeted a section, so honour it once the new page
    // has laid out. Otherwise land at the top: behavior:'auto' overrides the
    // global scroll-behavior:smooth, which would otherwise animate down the
    // length of the previous page while the new one is still laying out.
    const target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
    if (target) {
      target.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    // search is in the deps because blog pagination is a query param: page 2
    // must land at the top of the list like any other navigation.
  }, [location.pathname, location.hash, location.search]);
  return <div className="page" ref={pageRef} data-id="element-0" data-mp="33nq6btp41567">
      <Seo pathname={location.pathname} data-id="element-1" data-mp="33orik1hv3xpi" />
      <Analytics pathname={location.pathname} data-id="element-2" data-mp="38l8h7pmotugu" />
      <Crosshairs pageRef={pageRef} routeKey={`${location.pathname}${location.search}`} data-id="element-3" data-mp="38kgmeh0x00rm" />
      <Nav data-id="element-4" data-mp="3dmfpdpsqsvo1" />
      <main data-id="element-5" data-mp="3dirv2ofh4589">
        <Routes data-id="element-6" data-mp="3dii5h1ycc033">
          <Route path="/" element={<Index data-id="element-8" data-mp="nwc582htoe10" />} data-id="element-7" data-mp="nvsub5qlapwh" />
          <Route path="/how" element={<How data-id="element-10" data-mp="nxwx1kcr5iv6" />} data-id="element-9" data-mp="nv0ypuwzss67" />
          <Route path="/blog" element={<Blog data-id="element-12" data-mp="stkne32z0i29" />} data-id="element-11" data-mp="sudkecc4nt77" />
          <Route path="/blog/:slug" element={<Post data-id="element-14" data-mp="36hwt7ylgu1r" />} data-id="element-13" data-mp="st2iki28sviq" />
          <Route path="/contact" element={<Contact data-id="element-16" data-mp="356s95xbri9l" />} data-id="element-15" data-mp="35yp0k2nrm1g" />
          {/* The previous site shipped as .html files; the sitemap, llms.txt,
              and any inbound links still point there. Send them to the clean
              URLs rather than 404ing on the cutover. */}
          <Route path="/index.html" element={<Navigate to="/" replace data-id="element-18" data-mp="85bbh3pmar3i" />} data-id="element-17" data-mp="d2bhjemgvtum" />
          <Route path="/how.html" element={<Navigate to="/how" replace data-id="element-20" data-mp="3glea6jyr55fp" />} data-id="element-19" data-mp="86cmj86mvdl8" />
          <Route path="/contact.html" element={<Navigate to="/contact" replace data-id="element-22" data-mp="3gja35t5k3qb7" />} data-id="element-21" data-mp="3gm64zskiyz4x" />
          <Route path="/blog.html" element={<Navigate to="/blog" replace data-id="element-24" data-mp="3bo4lx7n3mztg" />} data-id="element-23" data-mp="3bn2zy84joswy" />
          {/* Anything else resolves to the homepage URL rather than rendering
              homepage content at an arbitrary path, which would duplicate it. */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-26" data-mp="2xuwsrbjddw9n" />} data-id="element-25" data-mp="3lj67jti61jra" />
          {/* Unknown article slugs are deliberately NOT caught above: /blog/:slug
              renders its own "that one isn't here" with a route back to Signals. */}
        </Routes>
      </main>
      <Footer data-id="element-27" data-mp="18cq6rn0wyktz" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-28" data-mp="1d47wfexhkyzn">
      <Routes data-id="element-29" data-mp="1d4reqwr1tpe7">
        {/* Rendered outside the site frame: it's an image to capture, not a page. */}
        <Route path="/og" element={<OgCard data-id="element-31" data-mp="yh6erbph06ai" />} data-id="element-30" data-mp="ygd4i0rayynm" />
        <Route path="/favicon" element={<FaviconCard data-id="element-33" data-mp="13eeul5n5by8l" />} data-id="element-32" data-mp="ydikubg45hv9" />
        <Route path="*" element={<Shell data-id="element-35" data-mp="13ey4q06k1ic2" />} data-id="element-34" data-mp="13fpzj8sbvc1a" />
      </Routes>
    </BrowserRouter>;
}